import React, { lazy, Suspense } from 'react';

const HeroSection     = lazy(() => import('./HeroSection'));
const OverviewSection = lazy(() => import('./OverviewSection'));
const FeaturesSection = lazy(() => import('./FeaturesSection'));
const CtaSection      = lazy(() => import('./CtaSection'));

export default function VcmPage() {
  return (
    <Suspense fallback={null}>
      <HeroSection />
      <OverviewSection />
      <FeaturesSection />
      <CtaSection />
    </Suspense>
  );
}
